import { inject, Injectable } from '@angular/core';
import { PermissionName } from '@app/core/permissions/enums/permission-name.enum';
import { UserType } from '@app/core/enums/user-type.enum';
import { GlobalPermissionsConditionsService } from '@app/core/permissions/configs/global-permissions-conditions.service';
import { IFeaturePermissions, IPermissionConfig } from '@app/core/permissions/interfaces/feature-permissions.interface';

@Injectable({
  providedIn: 'root',
})
export class GlobalPermissionsService implements IFeaturePermissions {
  private conditions = inject(GlobalPermissionsConditionsService);

  public CONFIGS: IPermissionConfig[] = [
    {
      name: PermissionName.Test,
      roles: [
        { role: UserType.Admin },
        {
          role: UserType.Viewer,
          condition$: this.conditions.testCondition$,
        },
        {
          role: UserType.Operator,
          condition$: this.conditions.testCondition$,
        },
      ],
    },
  ];
}
